// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1CaBB","modalForm":"UpgradeEpcsModal_modalForm__1YMLb","modalFooter":"UpgradeEpcsModal_modalFooter__3OqM5"};